import type { FaireProductEntity } from "../../entity_types/product";

export const p_559gtycve9: FaireProductEntity = {
  token: "p_559gtycve9",
  type: "product",
  name: "POLKA DOT SMOCKED BASQUE WAIST MIDI DRESS",
  brandToken: "b_1jsnz1e7d6",
  brandName: "Blu Pepper",
  imageUrl:
    "https://cdn.faire.com/fastly/2115b770303c62ccbe7f79c5282051392e16e42954617cd6f742e78ae3182b4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/613e41e0e11c8180b2a23c2d4b3449364fa2e94635f5b467edf9a122289b4f1e.jpeg",
    "https://cdn.faire.com/fastly/da6e35dc843f13adf0862a3eef50105abde747dfef0ee993a08cc0d8469efc9b.jpeg",
    "https://cdn.faire.com/fastly/3d9afc232253511d54e4cdac99029f187c93bdee9da302d37b6fdac3469f49fc.jpeg",
    "https://cdn.faire.com/fastly/ce1a57ef068a83e248c3112841f957f3b34006133dbb9db2ba79d7a511ef3f33.jpeg",
    "https://cdn.faire.com/fastly/6d3e528f4572b68c640a60a1bd384bb40082c13a73d19c6885341af0431de49e.jpeg",
    "https://cdn.faire.com/fastly/c1b01a8b9a66c29501e05749fd69a9fdfc61900eaac4fcd4163653409bdb0de6.jpeg",
    "https://cdn.faire.com/fastly/e90746e9cded45d5c18b542a43459b2bdb1a22cb42739b388db05e6cdfece382.jpeg",
    "https://cdn.faire.com/fastly/a9c774342492f8882b8c4af0656fdc9fcacf9fdbf3678f5e55ecbd86cc3e396d.jpeg",
    "https://cdn.faire.com/fastly/6ec0311874fdbb91c73b0522ff8dc428c99322a54753c0c7a2c14f3affd1a068.jpeg",
    "https://cdn.faire.com/fastly/02026495832597fadcb3409ab13d6c44a04ff6080a0b13c41a1fe1ffe18cd5b3.jpeg",
    "https://cdn.faire.com/fastly/a683d28931232da39df7e287709f83202554b4738790925ae7c3785f8eb243bd.jpeg",
    "https://cdn.faire.com/fastly/a1527d376fb9b84c2c1db4324369048328b934346e4bffb54a34f3b9a3e53440.jpeg",
    "https://cdn.faire.com/fastly/c94ee47f7efb2729a25e7abceba81df8d0fb684db2465ed258e1c46bbb75a223.jpeg",
    "https://cdn.faire.com/fastly/2f90f5c896791e2d990acf6a4092df0ad3344d51ab3f2c7c700abae4585beed1.jpeg",
    "https://cdn.faire.com/fastly/f8b079211704692d57ad2f72c7a5bcdcf386afb8b4a9dda373862045439d971b.jpeg",
    "https://cdn.faire.com/fastly/b41dae8a1aa212f28cdb5056f3d065b143aca3925f8523194c79bec635ad0538.jpeg",
    "https://cdn.faire.com/fastly/86a508aff37fc2f11f67a9721d22868b28530df6088630c4dd04ef715da13ad0.jpeg",
    "https://cdn.faire.com/fastly/582f1dbbbdaf27b01ac275e46ff256d9654856ce616af3c789e84f9ae29912af.jpeg",
    "https://cdn.faire.com/fastly/4ab8d44698253798a59718e9696ac57c719340d4cd6aafd75c3ea237d10d70e2.jpeg",
    "https://cdn.faire.com/fastly/6e1552dffd00833d3a5d279f6bac2cdc8ace1a5d928bddb423683d0f88507878.jpeg",
    "https://cdn.faire.com/fastly/ffdfb5ed6b09ad4a91e05bb3a70189c27b2b98805fec90e67ab9676191ac105a.jpeg",
    "https://cdn.faire.com/fastly/2bbd8395aaa4e9c9954941f4abb80c4f89b71916614b2161ef7969d3518860c5.jpeg",
    "https://cdn.faire.com/fastly/8c05aba7675084234cf08e83d42f5d222b2064100f30dbf267471ba13532f4b9.jpeg",
    "https://cdn.faire.com/fastly/911a8fedc5baf707dc31792bf0054c8a950b0626689809353a42374bdd7746c5.jpeg",
  ],
  priceDollars: 16.75,
  description:
    "CR2956A\n2 SMALL 2 MEDIUM 2 LARGE\nSCOOP NECKLINE\nADJUSTABLE SPAGHETTI STRAP\nSMOCKED BODICE\nBASQUE WAIST DETAIL\nA-LINE\nPOLKA DOT PATTERN\nLINED\nMIDI DRESS\nSHELL:82%RAYON 18%NYLON\nLINING:100%POLYESTER",
  tags: [],
  msrpDollars: 50.25,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:52.797Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
